<template>
    <div class="all">
      <my-title :msg="title"></my-title>
      <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 10px">
        <el-col :span="6">
          <div class="grid-content">留言内容</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">姓名</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">电话</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">公司名称</div>
        </el-col>
<!--        <el-col :span="4">
          <div class="grid-content">操作</div>
        </el-col>-->
      </el-row>
      <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 2px" v-for="(item,key) in OrderList" :key="key">
        <el-col :span="6">
          <div class="grid-content">{{item.content}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">{{item.phone}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">{{item.name}}</div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">{{item.ness}}</div>
        </el-col>
<!--        <el-col :span="4">
          <div class="grid-content">
            <el-button type="primary" @click="getFind(item.id)">查看详情</el-button>
            <el-button type="danger">退货</el-button>
          </div>
        </el-col>-->
      </el-row>
      <el-dialog title="详细信息" :visible.sync="dialogFormVisible">
        <el-form :model="findOr">
          <el-form-item label="订单号" :label-width="formLabelWidth">
            <el-input v-model="findOr.order_num" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="总金额" :label-width="formLabelWidth">
            <el-input v-model="findOr.price" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="省" :label-width="formLabelWidth">
            <el-input v-model="findOr.pro_name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="市" :label-width="formLabelWidth">
            <el-input v-model="findOr.city_name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="区" :label-width="formLabelWidth">
            <el-input v-model="findOr.area_name" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="详细地址" :label-width="formLabelWidth">
            <el-input v-model="findOr.add_ress" autocomplete="off" :disabled="true"></el-input>
          </el-form-item>
          <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 10px">
            <el-col :span="10">
              <div class="grid-content">商品名称</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">单价</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">总价</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">数量</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">时间</div>
            </el-col>
          </el-row>
          <el-row style="background: #e7e7e7;line-height: 50px;margin-top: 2px" v-for="(item,index) in findOr.goods" :key="index">
            <el-col :span="10">
              <div class="grid-content" style="line-height: 20px">{{item.goods_name}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.total_price}}</div>
            </el-col>
            <el-col :span="3">
              <div class="grid-content">{{item.num}}</div>
            </el-col>
            <el-col :span="4">
              <div class="grid-content">{{item.add_time | filterDate('yyyy/MM/dd')}}</div>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  import {getliuyan} from '../api/Mycen'
    export default {
        name: "Liuyan",
        data(){
          return{
            title:'留言列表',
            input:'',
            value:'',
            value1:'',
            form:{
              name:''
            },
            OrderList:[],
            dialogTableVisible: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            findOr:{
              goods:[]
            },
            //筛选
            order_num:'',
            status:'',
            sta_time:'',
            end_time:'',
          }
        },
        mounted() {
          this.init()
        },
        methods:{
          parseTime(d) {
            var newDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' '
              + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
            return new Date(newDate).getTime();
          },
          init(){
     /*       this.sta_time = this.parseTime(this.value1[0])
            this.end_time = this.parseTime(this.value1[1])*/
            getliuyan({

            }).then(res=>{
              this.OrderList = res.result
            })
          },
          getFind(id){
            getOrFind({id:id}).then(res=>{
              this.findOr = res.result
              this.dialogFormVisible = true
            })
          }
        }
    }
</script>

<style scoped lang="less">
  @import "css/Order";
</style>



// WEBPACK FOOTER //
// src/components/Liuyan.vue